export const SITE_URL = 'https://hipobuyspread.baby';